<template>
  <div>
    <div class="plan">
      <div class="t">
        信息更新
        <div v-if="status == -1" class="statusShow error">审核退回</div>
        <div v-if="status == 0" class="statusShow waiting">审核中</div>
        <div v-if="status == 1" class="statusShow end">审核通过</div>
      </div>
      <div class="return" @click="$router.back(-1)">
        返回上一级 <img src="@/assets/img/return.png" alt="" />
      </div>
    </div>
    <div class="statusBox">
      <img v-if="status == -1" src="@/assets/img/error.png" alt="" />
      <img v-if="status == 1" src="@/assets/img/success.png" alt="" />
      <img v-if="status == 0" src="@/assets/img/wait.png" alt="" />
      <div class="statusCont">
        <div class="item">
          <span class="t">审核状态：</span>
          <span class="c" v-if="status == -1">审核退回</span>
          <span class="c" v-if="status == 1">审核通过</span>
          <span class="c" v-if="status == 0">审核中</span>
        </div>
        <div class="item" v-if="status == -1 || status == 1">
          <span class="t">审核时间：</span>
          <span class="c">{{ exam_time }}</span>
        </div>

        <div class="item" v-if="status == -1 || status == 0">
          <span class="t">审核反馈：</span>
          <span v-if="status == -1" class="c">{{
            remarks ? remarks : "无"
          }}</span>
          <span v-if="status == 0" class="c"
            >您提交的信息正在审核中，请耐心等待</span
          >
        </div>
      </div>
    </div>
    <div class="headBox">
      <div class="title">更新前</div>
      <div class="title">更新后</div>
    </div>

    <!--      职称人数变化-->

    <div class="bg">
      <div class="contBox" style="margin-bottom: 48px">
        <div class="contT">1. 专职专业人员人数</div>
        <div class="contRightCont">
          <div class="cont">
            <div class="each">
              <div class="eachT">总人数</div>
              <div class="eachD">
                {{ upOldNumber.all }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">总人数</div>
              <div class="eachD">
                {{ upNewNumber.all }}
              </div>
            </div>
          </div>
          <div class="cont">
            <div class="each">
              <div class="eachT">高级职称人数</div>
              <div class="eachD">
                {{ upOldNumber.top }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">高级职称人数</div>
              <div class="eachD">
                {{ upNewNumber.top }}
              </div>
            </div>
          </div>
          <div class="cont">
            <div class="each">
              <div class="eachT">中级职称人数</div>
              <div class="eachD">
                {{ upOldNumber.middle }}
              </div>
            </div>
            <div class="each">
              <div class="eachT">中级职称人数</div>
              <div class="eachD">
                {{ upNewNumber.middle }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 专职专业人员信息-->
      <div
        v-if="(newArr && newArr.length) || (oldArr && oldArr.length)"
        style="margin-bottom: 48px"
      >
        <div class="contBox">
          <div class="contT" style="padding-top: 10px">2. 专职专业人员信息</div>
          <div class="contRightCont"></div>
        </div>
        <div class="contBox">
          <div class="contT"></div>
          <div class="contRightCont">
            <!--          变更前-->
            <div class="border" v-for="(item1, index) in oldArr" :key="index">
              <div class="cont">
                <div class="each">
                  <div class="eachT">姓名</div>
                  <div class="eachD">
                    {{ item1.name }}
                  </div>
                </div>
              </div>
              <div class="cont" v-if="item1.idcard">
                <div class="each">
                  <div class="eachT">身份证号</div>
                  <div class="eachD">
                    {{ item1.idcard }}
                  </div>
                </div>
              </div>
              <div class="cont" v-if="item1.idcard_f_image">
                <div class="each">
                  <div class="eachT">身份证（正面）</div>
                  <a :href="item1.idcard_f_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>

              <div class="cont" v-if="item1.idcard_b_image">
                <div class="each">
                  <div class="eachT">身份证（反面）</div>
                  <a :href="item1.idcard_b_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>

              <div class="cont" v-if="item1.major">
                <div class="each">
                  <div class="eachT">专业</div>
                  <div class="eachD">
                    {{ item1.major }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item1.phone">
                <div class="each">
                  <div class="eachT">联系电话</div>
                  <div class="eachD">
                    {{ item1.phone }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item1.title">
                <div class="each">
                  <div class="eachT">职称</div>
                  <div class="eachD">
                    {{ item1.title }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item1.cert_name">
                <div class="each">
                  <div class="eachT">具备执(从)业资格证书名称</div>
                  <div class="eachD">
                    {{ item1.cert_name }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item1.cert_number">
                <div class="each">
                  <div class="eachT">注册证书编号</div>
                  <div class="eachD">
                    {{ item1.cert_number }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item1.cert_exp_time">
                <div class="each">
                  <div class="eachT">证书有效期</div>
                  <div class="eachD">
                    {{ item1.cert_exp_time }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item1.cert_image">
                <div class="each">
                  <div class="eachT">具备执（从）业资格证书</div>
                  <a :href="item1.cert_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>

              <div class="cont" v-if="item1.title_image">
                <div class="each">
                  <div class="eachT">职称证书</div>
                  <a :href="item1.title_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="contRightCont">
            <!--          变更后-->
            <div class="border" v-for="(item2, index) in newArr" :key="index">
              <div class="cont">
                <div class="each">
                  <div class="eachT">姓名</div>
                  <div class="eachD">
                    {{ item2.name }}
                  </div>
                </div>
              </div>
              <div class="cont" v-if="item2.idcard">
                <div class="each">
                  <div class="eachT">身份证号</div>
                  <div class="eachD">
                    {{ item2.idcard }}
                  </div>
                </div>
              </div>
              <div class="cont" v-if="item2.idcard_f_image">
                <div class="each">
                  <div class="eachT">身份证（正面）</div>
                  <a :href="item2.idcard_f_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>

              <div class="cont" v-if="item2.idcard_b_image">
                <div class="each">
                  <div class="eachT">身份证（反面）</div>
                  <a :href="item2.idcard_b_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>

              <div class="cont" v-if="item2.major">
                <div class="each">
                  <div class="eachT">专业</div>
                  <div class="eachD">
                    {{ item2.major }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item2.phone">
                <div class="each">
                  <div class="eachT">联系电话</div>
                  <div class="eachD">
                    {{ item2.phone }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item2.title">
                <div class="each">
                  <div class="eachT">职称</div>
                  <div class="eachD">
                    {{ item2.title }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item2.cert_name">
                <div class="each">
                  <div class="eachT">具备执(从)业资格证书名称</div>
                  <div class="eachD">
                    {{ item2.cert_name }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item2.cert_number">
                <div class="each">
                  <div class="eachT">注册证书编号</div>
                  <div class="eachD">
                    {{ item2.cert_number }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item2.cert_exp_time">
                <div class="each">
                  <div class="eachT">证书有效期</div>
                  <div class="eachD">
                    {{ item2.cert_exp_time }}
                  </div>
                </div>
              </div>

              <div class="cont" v-if="item2.cert_image">
                <div class="each">
                  <div class="eachT">具备执（从）业资格证书</div>
                  <a :href="item2.cert_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>

              <div class="cont" v-if="item2.title_image">
                <div class="each">
                  <div class="eachT">职称证书</div>
                  <a :href="item2.title_image" target="_blank" class="eachC"
                    >查看文件</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--      人员新增信息-->
      <div class="contBox" v-if="createArr && createArr.length">
        <div
          v-if="(newArr && newArr.length) || (oldArr && oldArr.length)"
          class="contT"
        >
          3. 人员新增信息
        </div>
        <div v-else class="contT">2. 人员新增信息</div>
        <div class="contRightCont">
          <!--          变更前-->
          <div class="border" v-for="(it1, index) in createArr" :key="index">
            <div class="cont">
              <div class="each">
                <div class="eachT">姓名</div>
                <div class="eachD">无</div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">身份证号</div>
                <div class="eachD while">
                  {{ it1.idcard }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">身份证（正面）</div>
                <a
                  :href="it1.idcard_f_image"
                  target="_blank"
                  class="eachC while"
                  >查看文件</a
                >
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">身份证（反面）</div>
                <a
                  :href="it1.idcard_b_image"
                  target="_blank"
                  class="eachC while"
                  >查看文件</a
                >
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">专业</div>
                <div class="eachD while">
                  {{ it1.major }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">联系电话</div>
                <div class="eachD while">
                  {{ it1.phone }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">职称</div>
                <div class="eachD while">
                  {{ it1.title }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">具备执(从)业资格证书名称</div>
                <div class="eachD while">
                  {{ it1.cert_name }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">注册证书编号</div>
                <div class="eachD while">
                  {{ it1.cert_number }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">证书有效期</div>
                <div class="eachD while">
                  {{ it1.cert_exp_time }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">具备执(从)业资格证书名称</div>
                <a :href="it1.cert_image" target="_blank" class="eachC while"
                  >查看文件</a
                >
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT while">职称证书</div>
                <a :href="it1.title_image" target="_blank" class="eachC while"
                  >查看文件</a
                >
              </div>
            </div>
          </div>
        </div>
        <div class="contRightCont">
          <!--          变更后-->
          <div class="border" v-for="(it2, index) in createArr" :key="index">
            <div class="cont">
              <div class="each">
                <div class="eachT">姓名</div>
                <div class="eachD">
                  {{ it2.name }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">身份证号</div>
                <div class="eachD">
                  {{ it2.idcard }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">身份证（正面）</div>
                <a :href="it2.idcard_f_image" target="_blank" class="eachC"
                  >查看文件</a
                >
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">身份证（反面）</div>
                <a :href="it2.idcard_b_image" target="_blank" class="eachC"
                  >查看文件</a
                >
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">专业</div>
                <div class="eachD">
                  {{ it2.major }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">联系电话</div>
                <div class="eachD">
                  {{ it2.phone }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">职称</div>
                <div class="eachD">
                  {{ it2.title }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">具备执(从)业资格证书名称</div>
                <div class="eachD">
                  {{ it2.cert_name }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">注册证书编号</div>
                <div class="eachD">
                  {{ it2.cert_number }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">证书有效期</div>
                <div class="eachD">
                  {{ it2.cert_exp_time }}
                </div>
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">具备执（从）业资格证书</div>
                <a :href="it2.cert_image" target="_blank" class="eachC"
                  >查看文件</a
                >
              </div>
            </div>
            <div class="cont">
              <div class="each">
                <div class="eachT">职称证书</div>
                <a :href="it2.title_image" target="_blank" class="eachC"
                  >查看文件</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { updateDetail } from "@/api/update.js";

export default {
  name: "updateResult",
  created() {
    this.id = this.$route.query.id;
    this.init();
  },
  data() {
    return {
      id: "",

      upOld: [], //人员 变更前
      upNew: [], //人员 变更后

      oldArr: [], //最终 人员 变更前
      newArr: [], //最终 人员 变更后

      createArr: [], //新增的数组

      upNewNumber: {}, //人员 变更后 数量
      upOldNumber: {}, //人员 变更前 数量

      differentNew: {}, //更新后不同
      differentOld: {}, //更新前不同

      status: null, //状态
      exam_time: null, //审核时间
      remarks: null, //反馈
    };
  },
  methods: {
    //判断只有名字没有其他键值

    async init() {
      const res = await updateDetail({ id: this.id });

      //总状态
      this.status = res.info.status;

      this.exam_time = res.info.exam_time;
      this.remarks = res.info.remarks;

      //变更后
      this.upNewNumber = res.new_count;
      //变更前
      this.upOldNumber = res.old_count;

      //新增人员变更前后
      this.createArr = res.create;

      //专职专业人员 变化前后
      this.upNew = res.new;
      this.upOld = res.old;

      let temp_diff = [];
      //如果有数组则进行比较
      if (this.upNew && this.upNew.length && this.upOld && this.upOld.length) {
        //都有数据可以进行对比

        for (let [index1] of this.upNew.entries()) {
          for (let [index2] of this.upOld.entries()) {
            if (index1 == index2) {
              //确认 变化前 和 变化后 是同一个人的数据
              // console.log(this.upNew[index1]);
              //console.log(this.upOld[index2]);

              let temp_old = {};
              let temp_new = {};
              for (let i in this.upNew[index1]) {
                //循环这个人 变化后 的这条数据
                // console.log(i);
                for (let k in this.upOld[index2]) {
                  //循环这个人 变化前 的这条数据
                  //  console.log(k, ",.,.,.,..,.", i);
                  //键名相同
                  if (i == k) {
                    //比较值
                    //  console.log(this.upOld[index2], "this.upOld[index2]");
                    // console.log(this.upOld[index2].k, "this.upOld[index2].k"); //null
                    // console.log(this.upOld[index2][k], "this.upOld[index2][k]"); //1
                    let tempoldKey = this.upOld[index2][k];
                    let tempnewKey = this.upNew[index1][k];
                    // 备注：将null 空字符串 统一转换成空字符串
                    tempoldKey = tempoldKey ? tempoldKey : "";
                    tempnewKey = tempnewKey ? tempnewKey : "";
                    // if (tempoldKey != tempnewKey || k == "name") {
                    if (tempoldKey != tempnewKey || k == "name") {
                      // console.log(
                      //   this.upOld[index2][k],
                      //   "this.upOld[index2].k",
                      //   k
                      // );
                      // console.log(
                      //   this.upNew[index1][k],
                      //   "this.upNew[index1].i",
                      //   k
                      // );
                      //
                      temp_old[k] = this.upOld[index2][k];
                      temp_new[k] = this.upNew[index1][k];
                      //  temp_diff.push({});
                      // this.differentOld = this.upOld[index2]; //[k];
                      // this.differentNew = this.upNew[index1]; //[k];
                    }
                  }
                }
              }
              temp_diff.push({ old: temp_old, new: temp_new });
            }
          }
        }

        // console.log(temp_diff, "<><><");
        //去除数组里面不要的属性
        temp_diff.forEach((t) => {
          // console.log(t, "t");
          // console.log(t.old, "t.old");
          for (let h in t) {
            //删除不要的属性
            // console.log(h, "h");
            delete t[h].id;
            delete t[h].update_type;
            delete t[h].com_id;
            delete t[h].update_for;
            delete t[h].status;
            delete t[h].level;
          }
        });
        // console.log(temp_diff, "temp_diff");
        //重新做结构 改成一左一右 为了不去再改html部分的结构
        temp_diff.forEach((g) => {
          // console.log(g, "g");
          // console.log(g["old"], "old");
          //
          // console.log(g["new"], "new");
          //去除掉不要的剩下一个对象，空对象就不丢数组里面了
          if (
            JSON.stringify(g["old"]) == "{}" ||
            JSON.stringify(g["new"]) == "{}"
          ) {
            console.log("{}");
          } else {
            //变更后的 丢 变更后数组 里面
            this.newArr.push(g["new"]);
            //变更前的 丢 变更前数组 里面
            this.oldArr.push(g["old"]);
          }
        });

        // console.log(this.newArr, "this.newArr");
        // console.log(this.oldArr, "this.oldArr");

        //定义一个数组存放只有name并且数组长度为1的索引
        let indexArr = [];
        //循环两个数组，如果只有名字这一项，并且名字一致则不保留，移除数组
        this.newArr.forEach((i1, ind1) => {
          this.oldArr.forEach((i2, ind2) => {
            if (ind1 == ind2) {
              if (i1.name == i2.name) {
                //name 相同
                let a = Object.keys(i1);
                // console.log(a, "a");
                // console.log(a.length, "a.length");
                let b = Object.keys(i2);
                // console.log(b, "b");
                // console.log(b.length, "b.length");

                if (
                  a.length == 1 &&
                  b.length == 1 &&
                  a[0] == "name" &&
                  b[0] == "name"
                ) {
                  //删除数组里面这个对象
                  // console.log(a.length, "a.length");
                  // console.log(b.length, "b.length");
                  // console.log(ind1, "ind1=====");
                  // console.log(ind2, "ind2=====");
                  //
                  // console.log(this.newArr[0], "this.newArr[0]");
                  // console.log(this.oldArr[1], "this.oldArr[0]");

                  indexArr.push(ind1);
                }
              }
            }
          });
        });
        // console.log(indexArr, "indexArr");

        // console.log(this.newArr, "this.newArr------------");
        // console.log(this.oldArr, "this.oldArr------------");

        //循环这个索引数组
        // 方法一：
        // for (let i = indexArr.length - 1; i >= 0; i--) {
        //   console.log(indexArr[i], "i------->");
        //   this.newArr.splice(indexArr[i], 1);
        //   this.oldArr.splice(indexArr[i], 1);
        // }
        //方法二：
        indexArr.reverse();
        indexArr.forEach((item) => {
          //删除数组中的对应索引
          this.newArr.splice(item, 1);
          this.oldArr.splice(item, 1);
        });

        // console.log(this.newArr, "this.newArr");
        // console.log(this.oldArr, "this.oldArr");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.plan {
  height: 60px;
  background: #ffffff;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;

  .t {
    font-size: 20px;
    color: #333333;
    display: flex;
    align-items: center;

    .statusShow {
      font-size: 12px;
      color: #ffffff;
      margin-left: 8px;
      padding: 2px;
      border-radius: 2px;
    }

    .error {
      background: rgb(243, 35, 35);
    }

    .waiting {
      background: rgb(68, 150, 241);
    }

    .end {
      background: rgb(37, 162, 45);
    }
  }

  .return {
    display: flex;
    cursor: pointer;
    align-items: center;
    font-size: 14px;
    color: #4379f6;

    img {
      width: 12px;
      height: 10px;
      margin-left: 3px;
    }
  }
}

.statusBox {
  margin-top: 15px;
  background: #ffffff;
  border-radius: 2px;
  padding: 18px 58px;
  display: flex;
  align-items: center;

  img {
    width: 44px;
    height: 44px;
  }

  .statusCont {
    margin-left: 40px;

    .item {
      display: flex;
      align-items: center;
      margin-top: 10px;

      &:first-child {
        margin-top: unset;
      }

      .t {
        font-size: 12px;
        color: #999999;
      }

      .c {
        font-size: 12px;
        color: #333333;
      }
    }
  }
}

.headBox {
  width: 100%;
  height: 50px;
  background: #eaeaea;
  border-radius: 2px 2px 0px 0px;
  margin-top: 20px;
  display: flex;
  align-items: center;

  .title {
    flex: 1;
    font-size: 12px;
    font-weight: 700;
    color: #333333;
    text-align: center;
  }
}

.bg {
  background: #ffffff;
  border-radius: 0 0 2px 2px;
  padding: 30px 20px 50px;

  .contBox {
    display: flex;
    align-items: flex-start;

    .contT {
      font-size: 12px;
      font-weight: 700;
      color: #333333;
      min-width: 150px;
    }

    .border {
      border-bottom: 1px solid #dddddd;
      padding-bottom: 19px;
      margin-bottom: 19px;
    }

    .contRightCont {
      flex: 1;

      .cont {
        display: flex;
        margin-top: 16px;

        &:first-child {
          margin-top: unset;
        }

        .each {
          width: 50%;

          .eachT {
            font-size: 12px;
            color: #999999;
          }

          .eachD {
            font-size: 12px;
            color: #333333;
            margin-top: 4px;
          }

          .eachC {
            font-size: 12px;
            color: #4379f6;
            margin-top: 4px;
          }
        }
      }

      .while {
        color: #fff !important;
      }
    }
  }
}

.red {
  color: red !important;
  font-size: 12px;
  margin-top: 4px;
}
</style>
